import React from 'react';
/**
 * DjayNarrator — "Djay explains / greets you". A neutral narrator whose look is
 * irrelevant, so it intentionally renders the brand-default Djay.
 *
 * Accepts NO look props by design — onboarding, login/register, teacher/parent
 * portals, error boundaries and explainer surfaces should never accidentally pick
 * up a learner's collectible look.
 *
 * See docs/audits/MASCOT_SSOT_ARCHITECTURE_AUDIT_2026.md §5.2 (intent C).
 */
import { DjayAvatar } from './DjayAvatar';
import type { DjayAvatarProps } from './DjayAvatar';
export type DjayNarratorProps = Omit<DjayAvatarProps, 'variant' | 'accessory' | 'tier'>;
export function DjayNarrator(props: DjayNarratorProps) {
  // No look forwarded → DjayAvatar falls back to its brand defaults.
  return <DjayAvatar {...props} data-id="element-3268" />;
}